export const PricingMethodsResource = {
  name: "Pricing Methods",
  path: "/inventory/settings/pricing-methods",
  access: ["read-pricingmethods"],
};
